export default "__VITE_ASSET__CbwLNB9R__"